import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// =============================================================================
// GOUVERNANCE MULTI-TENANT - OmniHub
// Ref: /app/memory/GOVERNANCE.md
// =============================================================================

/**
 * Récupère le tenant slug actuel depuis le localStorage.
 * À utiliser dans TOUS les appels API qui nécessitent le tenant.
 * 
 * @returns {string} Le slug du tenant (ex: "tef", "climatpac")
 */
export function getCurrentTenantSlug() {
  return localStorage.getItem('current_tenant_slug') || 'default';
}

/**
 * Headers standards pour les appels API avec tenant.
 * À utiliser dans TOUS les fetch() vers des routes tenant-aware.
 * 
 * @param {Object} additionalHeaders - Headers supplémentaires à merger
 * @returns {Object} Headers avec X-Tenant-ID
 * 
 * @example
 * fetch(url, { 
 *   headers: getTenantHeaders({ 'Content-Type': 'application/json' })
 * })
 */
export function getTenantHeaders(additionalHeaders = {}) {
  // 2026-05-13 — ajout du Bearer en fallback au cookie session_token.
  // Le cookie est parfois absent sur certaines requêtes (SameSite/CORS,
  // perte de contexte) → 403 intermittent sur les routes super_admin
  // (Gamora notamment). Le backend (TenantMiddleware) lit le cookie en
  // priorité, puis le header Authorization. Doublement = robustesse.
  const token = typeof localStorage !== 'undefined'
    ? localStorage.getItem('session_token')
    : null;
  return {
    'X-Tenant-ID': getCurrentTenantSlug(),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...additionalHeaders
  };
}
